export default __webpack_public_path__ + "static/fingerprint-stone-1-f82e9bdeea74c7b66a88f0471f9ddc22.jpg";